import Swiper, { Navigation, Controller, Autoplay, Pagination } from 'swiper';

Swiper.use([Navigation, Controller, Autoplay, Pagination]);
gsap.registerPlugin(ScrollTrigger);

function ready(fn) {
  if (document.readyState !== 'loading') {
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}

const init = () => {
  const $header = $('.page-header');
  const $hamburger = $header.find('.page-header__hamburger');
  const $menu = $header.find('.page-header__menu');
  const $parentLi = $menu.find('.menu-item-has-children');
  const $parentLinks = $parentLi.children('a');
  const $subMenus = $parentLi.children('.sub-menu');
  let isObserver = true;
  let wWidth = window.innerWidth;
  let observer;
  let lastKnownScrollPosition = window.scrollY;
  let ticking = false;
  let navState = false;
  let isScrollingDisabled = false;

  if (
    !('IntersectionObserver' in window) ||
    !('IntersectionObserverEntry' in window) ||
    !('isIntersecting' in window.IntersectionObserverEntry.prototype)
  ) {
    isObserver = false;
    document.documentElement.classList.remove('is-observer');
  }

  if (isObserver) {
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -15% 0px' }
    );
  }

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  function debounce(func, wait, immediate, ...args) {
    let timeout;
    return function () {
      const context = this;
      const later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  function disableScrolling() {
    const docHeight = document.body.clientHeight;
    const windowHeight = window.innerHeight;

    if (docHeight > windowHeight) {
      const html = document.documentElement;
      const { scrollTop } = html;
      html.classList.add('disable-scrolling');
      html.style.top = `${-scrollTop}px`;
    }

    isScrollingDisabled = true;
  }

  function enableScrolling() {
    const { top } = getComputedStyle(document.documentElement);
    const scrollTop = parseInt(top, 10);
    const html = document.documentElement;
    html.classList.remove('disable-scrolling');
    html.scrollTop = -scrollTop;

    isScrollingDisabled = false;
  }

  function updateHeader() {
    if (lastKnownScrollPosition > 30) {
      $header.addClass('is-scrolling');
    } else if (!isScrollingDisabled) {
      $header.removeClass('is-scrolling');
    }
  }

  const updateBackdrop = () => {
    const $link = $menu.find('.menu-item-has-children.is-opened');
    const subNavOpened = $link.length;

    if (subNavOpened) {
      $header.addClass('is-sub-nav');
    } else {
      $header.removeClass('is-sub-nav');
    }
  };

  function handleNavTouch(cur) {
    const $curLink = $(cur);
    const $curSubMenu = $curLink.siblings('.sub-menu');

    if ($curLink.parent().hasClass('is-opened')) {
      $curLink.parent().removeClass('is-opened');

      if (wWidth < 1024) {
        $curSubMenu.slideUp();
      }
    } else {
      $parentLi.removeClass('is-opened');
      $curLink.parent().addClass('is-opened');

      if (wWidth < 1024) {
        $subMenus.slideUp();
        $curSubMenu.slideDown();
      }
    }
  }

  function bindEvents() {
    // hamburger
    $hamburger.on('click', () => {
      if (navState) {
        $header.removeClass('is-opened');
        enableScrolling();
      } else {
        $header.addClass('is-opened');
        disableScrolling();
      }

      navState = !navState;
    });

    // prevent parent links
    $parentLinks.on('click', (e) => e.preventDefault());

    // handle touch nav
    $parentLinks.on('touchend', (e) => {
      const $cur = $(e.currentTarget);
      handleNavTouch($cur);
      updateBackdrop();
    });

    // hover over nav
    $menu.hover(() => {
      $header.addClass('is-scrolling');
    }, updateHeader);

    // hover on menu item
    $parentLi.hover(
      (e) => {
        if (wWidth >= 1024) {
          const $cur = $(e.currentTarget);
          $cur.addClass('is-opened');
          updateBackdrop();
        }
      },
      (e) => {
        if (wWidth >= 1024) {
          const $cur = $(e.currentTarget);
          $cur.removeClass('is-opened');
          updateBackdrop();
        }
      }
    );

    // Navigation with tabbing
    $(window).keyup((e) => {
      const code = e.keyCode ? e.keyCode : e.which;

      if (code === 9) {
        const $link = $menu.find('a:focus');

        if ($link.length && $link.parent().hasClass('menu-item-has-children')) {
          $header.addClass('is-scrolling');
          updateBackdrop();
          handleNavTouch($link);
        } else if (!$link.length || !$link.closest('.sub-menu').length) {
          $parentLi.removeClass('is-opened');
          updateBackdrop();
          updateHeader();

          if (wWidth < 1024) {
            $parentLi.children('.sub-menu').slideUp();
          }
        }
      }
    });

    // FOCUS STYLING
    // Let the document know when the mouse is being used
    document.body.addEventListener('mousedown', () => {
      document.body.classList.remove('is-tab');
    });

    // Re-enable focus styling when Tab is pressed
    document.body.addEventListener('keydown', (event) => {
      if (event.key === 'Tab') {
        document.body.classList.add('is-tab');
      }
    });
  }

  const initVimeoBlocks = () => {
    const blocks = document.querySelectorAll('.video-block');

    if (!blocks) return;
    blocks.forEach((el) => {
      const block = el;
      const iframe = block.querySelector('iframe');
      const durationEl = block.querySelector('.video-block__duration');
      const playEl = block.querySelector('.video-block__play');
      const player = new Vimeo.Player(iframe);

      player
        .getDuration()
        .then((duration) => {
          const minutes = Math.ceil(duration / 60);
          durationEl.innerHTML = `${minutes}min`;
        })
        .catch((error) => {
          console.log(error);
        });

      playEl.addEventListener('click', () => {
        block.classList.add('is-playing');
        player
          .play()
          .then(() => {})
          .catch((error) => {
            block.classList.remove('is-playing');
            console.log(error);
          });
      });

      player.on('pause', function () {
        block.classList.remove('is-playing');
      });
    });
  };

  const initPageSlider = () => {
    const blocks = document.querySelectorAll('.slider');

    if (!blocks) return;
    blocks.forEach((el) => {
      const block = el;
      const topEl = block.querySelector('.slider__top');
      const bottomEl = block.querySelector('.slider__bottom');
      const prevBtn = block.querySelector('.slider-btn--prev');
      const nextBtn = block.querySelector('.slider-btn--next');
      let topSlider;
      let bottomSlider;

      if (topEl) {
        topSlider = new Swiper(topEl, {
          slidesPerView: 'auto',
          centeredSlides: true,
          loop: true,
          speed: 600,
          autoplay: true,
          slidesOffsetBefore: 22,
          navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
          },
          breakpoints: {
            768: {
              slidesOffsetBefore: -45,
            },
            1280: {
              slidesOffsetBefore: 60,
            },
          },
        });
      }

      if (bottomEl) {
        bottomSlider = new Swiper(bottomEl, {
          slidesOffsetBefore: -22,
          slidesPerView: 'auto',
          centeredSlides: true,
          loop: true,
          speed: 600,
          breakpoints: {
            768: {
              slidesOffsetBefore: 45,
            },
            1280: {
              slidesOffsetBefore: -60,
            },
          },
        });
      }

      if (topSlider && bottomSlider) {
        topSlider.controller.control = bottomSlider;
        bottomSlider.controller.control = topSlider;
      }
    });
  };

  const initCarousels = () => {
    const blocks = document.querySelectorAll('.carousel');
    if (!blocks) return;

    blocks.forEach((el) => {
      const block = el;
      const carouselEl = block.querySelector('.carousel__swiper');
      const prevBtn = block.querySelector('.slider-btn--prev');
      const nextBtn = block.querySelector('.slider-btn--next');
      const paginationEl = block.querySelector('.carousel__pagination');

      const swiper = new Swiper(carouselEl, {
        loop: true,
        speed: 600,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
        pagination: {
          el: paginationEl,
          type: 'bullets',
          clickable: true,
        },
      });
    });
  };

  const initHero = () => {
    const hero = document.querySelector('.hero');
    if (!hero) return;
    const heroBtn = hero.querySelector('.hero__scroll');
    const img = hero.querySelector('img');
    const video = hero.querySelector('video');
    const els = [];
    if (img) els.push(img);
    if (video) els.push(video);

    if (heroBtn) {
      const scrollTarget = hero.nextElementSibling;
      const yOffset = -81;

      if (scrollTarget) {
        const y =
          scrollTarget.getBoundingClientRect().top +
          window.pageYOffset +
          yOffset;
        heroBtn.addEventListener('click', () => {
          scrollTarget.scrollIntoView({
            behavior: 'smooth',
          });
          window.scrollTo({ top: y, behavior: 'smooth' });
        });
      }
    }

    if (els) {
      gsap.to([els], {
        scale: 1,
        duration: 1,
      });

      gsap.to([els], {
        translateY: '20%',
        scrollTrigger: {
          trigger: hero,
          start: 'top top',
          end: 'bottom top',
          scrub: true,
        },
      });
    }
  };

  const initVideoBanner = () => {
    const container = document.querySelector('.video-banner');
    if (!container) return;
    const iframe = container.querySelector('iframe');
    const btn = container.querySelector('.video-banner__play');
    const player = new Vimeo.Player(iframe);

    btn.addEventListener('click', () => {
      player
        .requestFullscreen()
        .then()
        .catch((error) => {
          console.log(error);
          // an error occurred
        });
    });

    player.on('fullscreenchange', (data) => {
      if (data.fullscreen) {
        player
          .play()
          .then()
          .catch((e) => console.log(e));
      } else {
        player
          .pause()
          .then()
          .catch((e) => console.log(e));
      }

      player
        .setCurrentTime(0)
        .then()
        .catch((e) => console.log(e));
    });
  };

  const initCtaVimeo = () => {
    const $blocks = $('.cta-block--vimeo');
    if (!$blocks.length) return;

    $blocks.each((i, el) => {
      const $block = $(el);
      const $iframe = $block.find('iframe');
      const $btn = $block.find('.cta-block__play');
      const player = new Vimeo.Player($iframe[0]);

      $btn.on('click', () => {
        player
          .requestFullscreen()
          .then()
          .catch((error) => {
            console.log(error);
            // an error occurred
          });
      });

      player.on('fullscreenchange', (data) => {
        if (data.fullscreen) {
          $block.addClass('is-fullscreen');

          player
            .play()
            .then()
            .catch((e) => console.log(e));
        } else {
          $block.removeClass('is-fullscreen');

          player
            .pause()
            .then()
            .catch((e) => console.log(e));
        }

        player
          .setCurrentTime(0)
          .then()
          .catch((e) => console.log(e));
      });
    });
  };

  const initPopup = () => {
    const popup = document.querySelector('.popup');
    if (!popup) return;
    const btns = document.querySelectorAll('.js-contact');
    const popupClose = popup.querySelector('.popup__close');
    const popupFormWrap = popup.querySelector('.popup__form');

    // open popup
    btns.forEach((btn) => {
      btn.addEventListener('click', () => {
        popup.classList.add('is-opened');
        disableScrolling();
      });
    });

    const closePopup = () => {
      popup.classList.remove('is-opened');
      enableScrolling();
    };

    // close btn
    popupClose.addEventListener('click', closePopup);

    // close from success
    popupFormWrap.addEventListener(
      'click',
      function (e) {
        // loop parent nodes from the target to the delegation node
        for (
          let { target } = e;
          target && target !== this;
          target = target.parentNode
        ) {
          if (target.matches('.js-contact-close')) {
            closePopup.call(target, e);
            break;
          }
        }
      },
      false
    );

    // open when hash in the URL
    if (window.location.hash === '#contact-us') {
      popup.classList.add('is-opened');
      disableScrolling();
    }

    // check if clicked link hash
    $('a').on('click', (e) => {
      const { hash } = e.currentTarget;

      if (hash && hash === '#contact-us') {
        e.preventDefault();
        popup.classList.add('is-opened');
        disableScrolling();
      }
    });
  };

  const initAutoplayVideo = () => {
    const blocks = document.querySelectorAll('.autoplay-video');
    if (!blocks) return;

    blocks.forEach((block) => {
      const container = block;
      const video = container.querySelector('video');

      ScrollTrigger.create({
        trigger: container,
        start: 'top center',
        end: 'bottom top',
        onToggle: (self) => {
          if (self.isActive) {
            video.play().catch((err) => console.log(err));
          } else {
            video.pause();
          }
        },
      });
    });
  };

  const initImageText = () => {
    const container = document.querySelector('.image-text__swiper');
    if (!container) return;

    const swiper = new Swiper(container, {
      loop: true,
      speed: 600,
      autoplay: true,
    });
  };

  const initAccordion = () => {
    const blocks = document.querySelectorAll('.accordion');
    if (!blocks) return;

    blocks.forEach((block) => {
      const $container = $(block);
      const $rows = $container.find('.accordion__item');
      const $copy = $rows.find('.accordion__copy');
      const $btns = $rows.find('.accordion__btn');

      $btns.on('click', (e) => {
        const $cur = $(e.currentTarget);
        const $curRow = $cur.parent();

        if ($curRow.hasClass('is-opened')) {
          $curRow
            .removeClass('is-opened')
            .children('.accordion__copy')
            .slideUp();
        } else {
          $rows.removeClass('is-opened');
          $copy.slideUp();
          $curRow
            .addClass('is-opened')
            .children('.accordion__copy')
            .slideDown();
        }
      });
    });
  };

  const initParallax = () => {
    const $blocks = $('.js-parallax');
    if (!$blocks.length) return;

    $blocks.each((i, el) => {
      const $block = $(el);
      const $target = $block.find('.js-parallax-target');
      const translate = $target.data('translate');
      const isHero = $block.data('is-hero');
      const startTriggerPos = isHero ? 'top' : 'bottom';

      gsap.to($target[0], {
        translateY: translate,
        scrollTrigger: {
          trigger: $block[0],
          start: `top ${startTriggerPos}`,
          end: 'bottom top',
          scrub: true,
        },
      });
    });
  };

  const initGutter = () => {
    const container = document.querySelector('.page-content');
    if (!container) return;
    const gutter = container.querySelector('.page-content__gutter');
    const paths = gutter.querySelectorAll('path');

    ScrollTrigger.matchMedia({
      '(min-width: 768px)': () => {
        ScrollTrigger.create({
          trigger: container,
          start: 'top top',
          end: 'bottom bottom',
          pin: gutter,
        });
      },
    });

    gsap.to(paths, {
      duration: 4,
      opacity: 0,
      ease: 'power1.inOut',
      stagger: {
        from: 'random',
        amount: 3,
        repeat: -1,
        yoyo: true,
      },
    });

    $(window).on('load', () => {
      ScrollTrigger.refresh();
    });
  };

  /* FUNCTION CALLS */
  /* ============= */
  bindEvents();
  initVimeoBlocks();
  initPageSlider();
  initCarousels();
  initHero();
  // initPattern();
  initVideoBanner();
  initCtaVimeo();
  initPopup();
  initAutoplayVideo();
  initImageText();
  initAccordion();
  initParallax();
  initGutter();

  if (isObserver) {
    document.querySelectorAll('.js-visibility').forEach((el) => {
      observer.observe(el);
    });
  }

  document.addEventListener('scroll', () => {
    lastKnownScrollPosition = window.scrollY;

    if (!ticking) {
      window.requestAnimationFrame(() => {
        updateHeader();
        ticking = false;
      });

      ticking = true;
    }
  });

  const doneResizing = debounce(() => {
    const width = window.innerWidth;

    if (wWidth !== width) {
      wWidth = width;
      $header.removeClass('is-opened');
      $parentLi.removeClass('is-opened');

      if (wWidth < 1024) {
        $subMenus.slideUp();
      } else {
        $subMenus.show();

        if (navState) {
          enableScrolling();
          navState = false;
          $header.removeClass('is-opened');
        }
      }
    }
  }, 500);

  $(window).on('resize', doneResizing);

  // on load
  updateHeader();
};

ready(init);
